import moment from 'moment';
import { useState } from 'react';
import OrdersApi from '../../../../API/shipment/orders-api';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { DateInput, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS, WAREHOUSE_LIST } from '../../../../constans';
import { getDateSolid, setDateSolid } from '../../../../utils';
import styles from './styles.module.scss';
import { Button } from '../../../../components/Basic/Buttons';


const CreateOrderPopUp = ({ close = () => { } }) => {
  const [dateOrder, setDateOrder] = useState(new Date(setDateSolid(moment().startOf('day').add(1, 'day'))));

  const [sklad, setSklad] = useState(WAREHOUSE_LIST[0]);
  const [shopsDate, setShopsDate] = useState([
    { shop: 'ozon, yandex', date: new Date(setDateSolid(moment().startOf('day').add(3, 'day'))) },
    { shop: 'wb', date: new Date(setDateSolid(moment().startOf('day').add(2, 'day'))) }
  ]);


  const changeShopDate = ({ markets, date }) => {
    const updatedShop = shopsDate.find(s => s.shop === markets)
    console.log(updatedShop)
    updatedShop.date = new Date(setDateSolid(date))
    setShopsDate([...shopsDate.filter(s => s.shop !== markets), updatedShop])
  }

  const clickAdd = () => {
    OrdersApi.createOrder({ data: { timeScheduled: dateOrder, skladName: sklad.name, shopsDate } }).then((r) => {
      close();
    });
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Добавить новый заказ</H2>
      <Row>
        <Select
          list={WAREHOUSE_LIST}
          select={sklad}
          label="Склад отгрузки"
          valueFn={(v) => v.warehouse}
          onSelect={(v) => setSklad(v)}
          width={'150px'}
        />
        <div style={{ margin: '0px 0px 10px 40px' }}>
          <DateInput
            value={getDateSolid(dateOrder)}
            // classNameCalendar={styles.date_input_calendar}
            label='Дата заказа'
            onChange={(v) => setDateOrder(setDateSolid(v))} />
        </div>
      </Row>
      <InputLabel style={{ marginTop: '30px' }}>Дата отгрузки</InputLabel>
      <Row style={{ marginTop: '15px' }}>
        <H2 style={{ marginRight: '100px' }}>Wb</H2>
        {console.log()}
        <DateInput
          value={getDateSolid(shopsDate.find(s => s.shop === 'wb').date)}
          onChange={(v) => changeShopDate({ markets: 'wb', date: v })}
        />
      </Row>
      <Row style={{ marginTop: '10px' }}>
        <H2 style={{ marginRight: '20px' }}>Ozon+Yandex</H2>
        <DateInput
          value={getDateSolid(shopsDate.find(s => s.shop === 'ozon, yandex').date)}
          onChange={(v) => changeShopDate({ markets: 'ozon, yandex', date: v })}
        />
      </Row>
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={!dateOrder || !shopsDate.every(i => i.date)}
          style={{
            marginRight: '15px',
          }}
          onClick={clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CreateOrderPopUp;
